<bw-action-article-legacy [brightsideWebFb]="{ event_name: 'savings_account_creation' }">
  <div content-section>
    <div class="flex-column space-center">
      <bw-spinner-legacy></bw-spinner-legacy>
      <typography-legacy text-medium-semibold>
        {{ 'SENDING_INFORMATION' | translate }}
      </typography-legacy>
    </div>
  </div>
</bw-action-article-legacy>
